import {SipUserLazyQueryHookResult, SipUserQuery, useSipUserLazyQuery} from "../../queries.generated";

export default class SIPUserFetcher {
    private query: SipUserLazyQueryHookResult[0];

    constructor() {
        [this.query] = useSipUserLazyQuery({fetchPolicy: "no-cache"});
    }

    fetchSipUser = async (): Promise<SipUserQuery["sipUser"]> => {
        return (await this.query()).data.sipUser;
    };
}
